import { isUnknownObject, isString } from '~/shared/utils/guards'

export default class BreadcrumbItem {
  title: string = ''
  url: string = ''

  constructor(data?: unknown) {
    if (isUnknownObject(data)) {
      if (isString(data.title)) this.title = data.title
      if (isString(data.url)) this.url = data.url
    }
  }
}
